import { useState } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import OpenCloseArrowIcon from '../../icons/openCloseArrowIcon'
import { useMediaQuery } from '@mui/material'
interface Props {
  title?: string
  job?: string
  subTitle: string
  children: React.ReactNode
}
const SectionFormAccordion = ({ title, children, subTitle, job }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const isMobile = useMediaQuery('(max-width:800px)')
  const isSmallMobile = useMediaQuery('(max-width:480px)')

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <section>
      {title && (
        <Typography 
          variant='h5' 
          sx={{ 
            textTransform: 'uppercase', 
            mb: isSmallMobile ? '12px' : isMobile ? '16px' : '20px',
            fontSize: isSmallMobile ? '14px' : isMobile ? '16px' : '18px'
          }}
        >
          {title}
        </Typography>
      )}
      <Box
        sx={{
          border: '1px solid #DADCDD',
          pl: isSmallMobile ? '16px' : isMobile ? '20px' : '30px',
          pr: isSmallMobile ? '16px' : isMobile ? '20px' : '35px',
          ...(isOpen ? { pb: isSmallMobile ? '20px' : isMobile ? '28px' : '37px' } : {}),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            pb: isSmallMobile ? '20px' : isMobile ? '32px' : '44px',
            pt: isSmallMobile ? '20px' : isMobile ? '28px' : '34px',
          }}
          onClick={toggleAccordion}
        >
          <Box>
            <Typography 
              variant='h6' 
              sx={{ 
                textTransform: 'uppercase', 
                letterSpacing: '1px',
                fontSize: isSmallMobile ? '12px' : isMobile ? '14px' : '16px'
              }}
            >
              {subTitle}
            </Typography>
            {job && !isOpen && (
              <Typography 
                mt={isSmallMobile ? '6px' : '10px'}
                sx={{
                  fontSize: isSmallMobile ? '12px' : isMobile ? '14px' : '16px'
                }}
              >
                {job}
              </Typography>
            )}
          </Box>
          <OpenCloseArrowIcon open={isOpen} size='large' />
        </Box>
        {isOpen && <>{children}</>}
      </Box>
    </section>
  )
}

export default SectionFormAccordion
